// Global CSS Styles
import { css } from "@emotion/react"
import {
  weights,
  mediaQueries,
  fontSizeLineHeight,
  pxToRem,
  getFontWeight,
  getLetterSpacing,
  fonts,
  respSpacing,
} from "./css-utils"
import { DesktopBodyFontSize, DesktopBodyLineHeight, DesktopH1FontSize, DesktopH1LineHeight,  DesktopH2FontSize, DesktopH2LineHeight, DesktopH3FontSize, DesktopH3LineHeight, DesktopH4FontSize, DesktopH4LineHeight, DesktopH5FontSize, DesktopH5LineHeight, DesktopH6FontSize, DesktopH6LineHeight, DesktopSubtitleFontSize, DesktopSubtitleLineHeight, DesktopCaptionFontSize, DesktopCaptionLineHeight, FontFamiliesPrimary } from "../../tokens/js/desktop";
import { TabletBodyFontSize, TabletBodyLineHeight, TabletH1FontSize, TabletH1LineHeight, TabletH2FontSize, TabletH2LineHeight, TabletH3FontSize, TabletH3LineHeight, TabletH4FontSize, TabletH4LineHeight, TabletH5FontSize, TabletH5LineHeight, TabletH6FontSize, TabletH6LineHeight, TabletSubtitleFontSize, TabletSubtitleLineHeight, TabletCaptionFontSize, TabletCaptionLineHeight, } from "../../tokens/js/tablet";
import { MobileBodyFontFamily, MobileBodyFontSize, MobileBodyFontWeight, MobileBodyLineHeight, MobileCategoryFontFamily, MobileCategoryFontSize, MobileCategoryFontWeight, MobileCategoryLetterSpacing, MobileCategoryLineHeight, MobileH1FontFamily, MobileH1FontSize, MobileH1FontWeight, MobileH1LineHeight, MobileH2FontFamily, MobileH2FontSize, MobileH2FontWeight, MobileH2LineHeight, MobileH3FontFamily, MobileH3FontSize, MobileH3FontWeight, MobileH3LineHeight, MobileH4FontFamily, MobileH4FontWeight, MobileH5FontFamily, MobileH5FontSize, MobileH5FontWeight, MobileH5LineHeight, MobileH6FontFamily, MobileH6FontSize, MobileH6FontWeight, MobileH6LineHeight, MobileSubtitleFontFamily, MobileSubtitleFontSize, MobileSubtitleFontWeight, MobileSubtitleLineHeight, MobileTagFontFamily, MobileTagFontSize, MobileTagFontWeight, MobileTagLineHeight, MobileCaptionFontFamily, MobileCaptionFontSize, MobileCaptionFontWeight, MobileCaptionLineHeight } from "../../tokens/js/mobile";
import { NeutralTxtDefault, CanvasDefault, HighlightStrongBorderStrong, PrimaryTxtDefault, PrimaryBgWeakHover, PrimaryTxtInvDefault, NeutralTxtStrongDefault, NeutralBgDefault, NeutralBorderDefault, NeutralTxtWeakDefault } from "../../tokens/js/light";
import { Lime600, Neutral0, Neutral1000, Neutral600, Violet600 } from "../../tokens/js/colors";

// Headings
export const h1Sm = css`
  ${fontSizeLineHeight(MobileH1FontSize, MobileH1LineHeight)};
  margin-bottom: ${pxToRem(24)};
  font-family: ${MobileH1FontFamily}, sans-serif;
  font-weight: ${getFontWeight(MobileH1FontWeight)};
`

export const h1 = css`
  ${h1Sm}

  ${mediaQueries.md} {
    ${fontSizeLineHeight(TabletH1FontSize, TabletH1LineHeight)};
  }

  ${mediaQueries.lg} {
    ${fontSizeLineHeight(DesktopH1FontSize, DesktopH1LineHeight)};
    margin-bottom: ${pxToRem(32)};
  }
`

export const h2Sm = css`
${fontSizeLineHeight(MobileH2FontSize, MobileH2LineHeight)}
  margin-bottom: ${pxToRem(16)};
  font-family: ${MobileH2FontFamily}, sans-serif;
  font-weight: ${getFontWeight(MobileH2FontWeight)};
`

export const h2 = css`
  ${h2Sm}

  ${mediaQueries.md} {
    ${fontSizeLineHeight(TabletH2FontSize, TabletH2LineHeight)}
  }

  ${mediaQueries.lg} {
    ${fontSizeLineHeight(DesktopH2FontSize, DesktopH2LineHeight)}
    margin-bottom: ${pxToRem(24)};
  }
`

export const h3Sm = css`
  ${fontSizeLineHeight(MobileH3FontSize, MobileH3LineHeight)}
  margin-bottom: ${pxToRem(16)};
  font-family: ${MobileH3FontFamily}, sans-serif;
  font-weight: ${getFontWeight(MobileH3FontWeight)};
`

export const h3 = css`
  ${h3Sm}

  ${mediaQueries.md} {
    ${fontSizeLineHeight(TabletH3FontSize, TabletH3LineHeight)}
  }

  ${mediaQueries.lg} {
    ${fontSizeLineHeight(DesktopH3FontSize, DesktopH3LineHeight)}
    margin-bottom: ${pxToRem(24)};
  }
`

export const h4Sm = css`
  ${fontSizeLineHeight(18, 28)}
  margin-bottom: ${pxToRem(8)};
  font-family: ${MobileH4FontFamily};
  font-weight: ${getFontWeight(MobileH4FontWeight)};
`

export const h4 = css`
  ${h4Sm}

  ${mediaQueries.md} {
    ${fontSizeLineHeight(TabletH4FontSize, TabletH4LineHeight)}
  }

  ${mediaQueries.lg} {
    ${fontSizeLineHeight(DesktopH4FontSize, DesktopH4LineHeight)}
    margin-bottom: ${pxToRem(16)};
  }
`

export const h5Sm = css`
  ${fontSizeLineHeight(MobileH5FontSize, MobileH5LineHeight)}
  margin-bottom: ${pxToRem(8)};
  font-family: ${MobileH5FontFamily};
  font-weight: ${getFontWeight(MobileH5FontWeight)};
`

export const h5 = css`
  ${h5Sm}

  ${mediaQueries.md} {
    ${fontSizeLineHeight(TabletH5FontSize, TabletH5LineHeight)}
  }

  ${mediaQueries.lg} {
    ${fontSizeLineHeight(DesktopH5FontSize, DesktopH5LineHeight)}
    margin-bottom: ${pxToRem(16)};
  }
`

export const h6Sm = css`
  ${fontSizeLineHeight(MobileH6FontSize, MobileH6LineHeight)}
  margin-bottom: ${pxToRem(16)};
  font-family: ${MobileH6FontFamily};
  font-weight: ${getFontWeight(MobileH6FontWeight)};
`

export const h6 = css`
  ${h6Sm}

  ${mediaQueries.md} {
    ${fontSizeLineHeight(TabletH6FontSize, TabletH6LineHeight)}
  }

  ${mediaQueries.lg} {
    ${fontSizeLineHeight(DesktopH6FontSize, DesktopH6LineHeight)}
    margin-bottom: ${pxToRem(16)};
  }
`

export const subtitle = css`
  ${fontSizeLineHeight(MobileSubtitleFontSize, MobileSubtitleLineHeight)}
  font-family: ${MobileSubtitleFontFamily};
  font-weight: ${getFontWeight(MobileSubtitleFontWeight)};

  ${mediaQueries.md} {
    ${fontSizeLineHeight(TabletSubtitleFontSize, TabletSubtitleLineHeight)}
  }

  ${mediaQueries.lg} {
    ${fontSizeLineHeight(DesktopSubtitleFontSize, DesktopSubtitleLineHeight)}
  }
`;

export const captionStyles = css`
  ${fontSizeLineHeight(MobileCaptionFontSize, MobileCaptionLineHeight)}
  font-family: ${MobileCaptionFontFamily};
  font-weight: ${getFontWeight(MobileCaptionFontWeight)};

  ${mediaQueries.md} {
    ${fontSizeLineHeight(TabletCaptionFontSize, TabletCaptionLineHeight)}
  }

  ${mediaQueries.lg} {
    ${fontSizeLineHeight(DesktopCaptionFontSize, DesktopCaptionLineHeight)}
  }
`;

export const focusStyles = css`
  outline: ${pxToRem(2)} solid ${HighlightStrongBorderStrong};
  outline-offset: ${pxToRem(2)};
`;

export const linkStyles = css`
  position: relative;
  color: ${PrimaryTxtDefault};
  background-image: linear-gradient(to bottom, transparent 0%, transparent 0%),
    linear-gradient(
      to right,
      ${PrimaryBgWeakHover} 33%,
      transparent 33%,
      transparent 66%,
      transparent 66%
    );
  background-size: 306% 100%;
  background-position: 100% 0;
  transition: background-position 1s, color 1s;
  cursor: pointer;
  border-radius: ${pxToRem(2)};

  &:focus-visible {
    ${focusStyles};
  }

  &:hover,
  &:active,
  &:focus {
    background-position: 0%;
    color: ${PrimaryTxtInvDefault};
  }
`

// Body (baseline for paragraphs, list-items, etc.)
export const bodySm = css`
  ${fontSizeLineHeight(MobileBodyFontSize, MobileBodyLineHeight)};
  font-family: ${MobileBodyFontFamily}, sans-serif;
  font-weight: ${getFontWeight(MobileBodyFontWeight)};
  margin-bottom: ${pxToRem(24)}; // @todo remove this and find all the places it breaks
`

export const body = css`
  ${bodySm}

  ${mediaQueries.md} {
    ${fontSizeLineHeight(TabletBodyFontSize, TabletBodyLineHeight)};
  }

  ${mediaQueries.lg} {
    ${fontSizeLineHeight(DesktopBodyFontSize, DesktopBodyLineHeight)};
    margin-bottom: ${pxToRem(32)}; // @todo remove this and find all the places it breaks
  }
`

// Tables

// Styles shared by stacked and non-stacked table versions, without
// any responsive behavior
export const tableGlobalSm = css`
  border: ${pxToRem(1)} solid ${Neutral600};
  border-radius: ${pxToRem(12)};
  border-collapse: separate;
  border-spacing: 0;

  tr:not(:first-of-type){
    border-top: ${pxToRem(1)} solid ${Neutral600};
  }

  th {
    border-bottom: ${pxToRem(1)} solid ${Neutral600};
  }

  td {
    ${bodySm}
    margin: 0;
  }

  thead {
    tr {
      padding: 0;

      th {
        padding: ${pxToRem(8)};
      }
    }
  }
`

// Not stacked OR responsive
export const tableSm = css`
  ${tableGlobalSm}

  td {
    margin: 0;
    padding: ${pxToRem(8)};
  }

  tr:not(:first-of-type) td {
    border-top: ${pxToRem(1)} solid ${Neutral600};
  }
  
  td:not(:last-of-type),
  tr:not(:first-of-type) td:only-of-type {
    // second selector is for annoying edge case where there's only one td in 
    // a row because everything else is using rowspans
    border-right: ${pxToRem(1)} solid ${Neutral600};
  }
`

// Responsive, not stacked... the one we use most often
export const table = css`
  ${tableSm}

  td {
    ${body}
  }

  ${mediaQueries.md} {
    margin-bottom: ${pxToRem(32)};

    td,
    thead tr th {
      padding: ${pxToRem(16)};
    }
  }
`

export const tableStacked = css`
  ${tableGlobalSm}

  tr {
    display: flex;
    flex-direction: column;
    padding: ${pxToRem(8)};
  }

  td {
    ${body}
    margin: 0;
  }

  ${mediaQueries.md} {
    margin-bottom: ${pxToRem(32)};

    tr {
      display: table-row;
    }

    td {
      border-bottom: none;
      padding: ${pxToRem(16)};
    }

    tr:not(:first-of-type) td {
      border-top: ${pxToRem(1)} solid ${Neutral600};
    }
    
    td:not(:last-of-type) {
      border-right: ${pxToRem(1)} solid ${Neutral600};
    }
  }
`;

export const category = css`
  font-family: ${MobileCategoryFontFamily};
  ${fontSizeLineHeight(MobileCategoryFontSize, MobileCategoryLineHeight)};
  font-weight: ${getFontWeight(MobileCategoryFontWeight)};
  letter-spacing: ${getLetterSpacing(MobileCategoryLetterSpacing)};
`;

export const tag = css`
  font-family: ${MobileTagFontFamily};
  ${fontSizeLineHeight(MobileTagFontSize, MobileTagLineHeight)};
  font-weight: ${MobileTagFontWeight};
`;

export const visuallyHidden = css`
  position: absolute;
  clip: rect(0 0 0 0);
  clip-path: polygon(0 0, 0 0, 0 0);
  width: ${pxToRem(1)};
  height: ${pxToRem(1)};
  padding: 0;
  margin: ${pxToRem(-1)};
  border: 0;
  overflow: hidden;
  white-space: nowrap;
`

// Common spacing for components and sub-components
export const spaceLg = css`
  margin-bottom: ${pxToRem(80)};

  ${mediaQueries.lg} {
    margin-bottom: ${pxToRem(160)};
  }
`

export const spaceMd = css`
  margin-bottom: ${pxToRem(56)};

  ${mediaQueries.lg} {
    margin-bottom: ${pxToRem(112)};
  }
`

export const spaceSm = css`
  margin-bottom: ${pxToRem(32)};

  ${mediaQueries.lg} {
    margin-bottom: ${pxToRem(64)};
  }
`

export const spaceStacked = css`
  margin-bottom: ${pxToRem(24)};
`

// Styles common to our other lists; don't call this directly on a component
const listBaseSm = css`
  ${bodySm}
  list-style-type: none;
  padding: 0;
  margin: 0;

  li {
    position: relative;
   
    p {
      margin: 0;
    }

    &::before {
      position: absolute;
      left: 0;
    }
  }
`

const listBase = css`
  ${listBaseSm}
  ${body}
  
    
  ${mediaQueries.md} {
    margin: 0;
  }
`;

const bulletListOverrides = css`
  li {
    margin-bottom: ${pxToRem(16)};
    padding-inline-start: ${pxToRem(16)};

    ${mediaQueries.md} {
      padding-inline-start: ${pxToRem(24)};
    }

    &::before {
      content: '';
      width: ${pxToRem(8)};
      height: ${pxToRem(8)};
      top: ${pxToRem(8)};
      background: ${Violet600};

      ${mediaQueries.md} {
        top: ${pxToRem(12)};
      }
    }
    
    ul {
      padding-top: ${pxToRem(16)};
    }
  }
`

export const bulletsSm = [listBaseSm, bulletListOverrides];

export const bullets = [listBase, bulletListOverrides];

const checkmarkListOverride = css`
  li {
    margin-bottom: ${pxToRem(16)};
    padding-left: ${pxToRem(36)};
    
    &::before {
      content: '';
      width: ${pxToRem(24)};
      height: ${pxToRem(24)};
      top: ${pxToRem(4)};
      background-repeat: no-repeat;
      background-position: center;
      background-size: ${pxToRem(24)} ${pxToRem(24)};
      background-image: url("data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Ccircle%20cx%3D%2212%22%20cy%3D%2212%22%20r%3D%2212%22%20fill%3D%22%236046FF%22%2F%3E%0A%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M17.07%208.63137L15.9386%207.5L10.31%2013.1286L7.88137%2010.7L6.75%2011.8314L10.2976%2015.379L10.5385%2015.1381L10.5508%2015.1505L17.07%208.63137Z%22%20fill%3D%22white%22%2F%3E%0A%3C%2Fsvg%3E");
    }
  }
`

export const checkmarksSm = [listBaseSm, checkmarkListOverride];

export const checkmarks = [listBase, checkmarkListOverride];

export const checkmarksLime = [checkmarks, css`
  li::before {
    background-image: url("data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Ccircle%20cx%3D%2212%22%20cy%3D%2212%22%20r%3D%2212%22%20fill%3D%22%23D5F800%22%2F%3E%0A%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M17.07%208.63137L15.9386%207.5L10.31%2013.1286L7.88137%2010.7L6.75%2011.8314L10.2976%2015.379L10.5385%2015.1381L10.5508%2015.1505L17.07%208.63137Z%22%20fill%3D%22%232B3200%22%2F%3E%0A%3C%2Fsvg%3E");
  }
`]

const plusListOverride = css`
  li {
    margin-bottom: ${pxToRem(16)};
    padding-left: ${pxToRem(36)};
    
    &::before {
      content: '';
      width: ${pxToRem(24)};
      height: ${pxToRem(24)};
      top: ${pxToRem(0)};
      background-repeat: no-repeat;
      background-position: center;
      background-size: ${pxToRem(24)} ${pxToRem(20)};
      background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg id='plus'%3E%3Cpath id='Icon' d='M12 6C11.4477 6 11 6.44772 11 7V11H7C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13H11V17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V13H17C17.5523 13 18 12.5523 18 12C18 11.4477 17.5523 11 17 11H13V7C13 6.44772 12.5523 6 12 6Z' fill='%23A090FF'/%3E%3C/g%3E%3C/svg%3E");
    }
  }
`

export const plusSm = [listBaseSm, plusListOverride];

export const plus = [listBase, plusListOverride];

const numberListOverride = css`
  counter-reset: li;
  li::before {
    content: counter(li);
    counter-increment: li;
    top: ${pxToRem(0)};
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    text-align: center;
    ${fontSizeLineHeight(13, 20)}
    font-family: ${fonts.primary};
    font-weight: ${weights.bold};
    background: ${Violet600};
    color: ${Neutral0};
  }
  ul li::before { /* So nested uls don't inherit the numbers */
    content: '';
    width: ${pxToRem(8)};
    height: ${pxToRem(8)};
    top: ${pxToRem(5)};
    counter-increment: none;
  }
`

export const numbersSm = [checkmarksSm, numberListOverride];

export const numbers = [checkmarks, numberListOverride, css`
  ${mediaQueries.md} {
    li::before {
      top: ${pxToRem(4)};
    }

    ul li::before { /* So nested uls don't inherit the numbers */
      top: ${pxToRem(11)};
    }
  }
`];

export const numbersLime = [numbers, css`
  li::before {
    background: ${Lime600};
    color: ${Neutral1000};
  }
`]

export const inputStyles = css`
  ${fontSizeLineHeight(13,16)};
  width: 100%;
  padding: ${pxToRem(12)};
  border-radius: ${pxToRem(8)};
  border: ${pxToRem(2)} solid ${NeutralBorderDefault};
  background: ${NeutralBgDefault};
  font-family: ${fonts.secondary};
  color: ${NeutralTxtDefault};
  font-weight: ${weights.medium};

  &::placeholder {
    color: ${NeutralTxtWeakDefault};
  }

  &:focus {
    outline: ${pxToRem(2)} solid ${HighlightStrongBorderStrong};
    outline-offset: ${pxToRem(2)};
  }

  ${mediaQueries.md} {
    padding: ${pxToRem(12)} ${pxToRem(16)};
  }

  ${mediaQueries.xl} {
    padding: ${pxToRem(16)};
    ${fontSizeLineHeight(16,24)};
  } 
`;

//Light theme
export const globalStyles = css`
  *,
  *::before,
  &::after {
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    padding: 0;
    margin: 0;
    font-family: ${FontFamiliesPrimary};
    line-height: 1.75;

    //Light theme
    color: ${NeutralTxtDefault};
    background: ${CanvasDefault};
  }

  strong {
    font-weight: ${weights.bold};
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${NeutralTxtStrongDefault};
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin-top: 0;
  }

  p {
    ${body}
  }

  sup,
  sub {
    font-size: 65%;
    line-height: 1;
    position: relative;
  }

  h2:not([class]) {
    ${h2}
  }

  h3:not([class]) {
    ${h3}
  }

  h4:not([class]) {
    ${h4}
  }

  h5:not([class]) {
    ${h5}
  }

  h6:not([class]) {
    ${h6}
  }

  table:not([class]) {
    ${table}
  }

  table.table--stacked {
    ${tableStacked}
  }

  a:not([class]) {
    ${linkStyles}
  }

  ul:not([class]) {
    ${bullets}
  }

  ol:not([class]) {
    ${numbers}

    &[start="2"] {
      counter-reset: li 1;
    }

    &[start="3"] {
      counter-reset: li 2;
    }

    &[start="4"] {
      counter-reset: li 3;
    }

    &[start="5"] {
      counter-reset: li 4;
    }

    &[start="6"] {
      counter-reset: li 5;
    }

    &[start="7"] {
      counter-reset: li 6;
    }

    &[start="8"] {
      counter-reset: li 7;
    }
  }

  input, textarea, select {
    ${inputStyles};
  }

  select {
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2225%22%20viewBox%3D%220%200%2024%2025%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20d%3D%22M6.90002%2010.5371C6.90002%2010.2371%207.00002%2010.0371%207.20002%209.83711C7.60002%209.43711%208.20002%209.43711%208.60002%209.83711L12.1%2013.3371L15.6%209.83711C16%209.43711%2016.6%209.43711%2017%209.83711C17.4%2010.2371%2017.4%2010.8371%2017%2011.2371L12.8%2015.4371C12.4%2015.8371%2011.8%2015.8371%2011.4%2015.4371L7.20002%2011.2371C7.00002%2011.0371%206.90002%2010.8371%206.90002%2010.5371Z%22%20fill%3D%22%23646F75%22%2F%3E%0A%3C%2Fsvg%3E%0A");
    background-repeat: no-repeat;
    background-position: calc(100% - 10px);
    padding-right: 80px;
  }

  label {
    ${fontSizeLineHeight(13,18)};
    color: ${NeutralTxtDefault};
    padding-left: ${pxToRem(2)};
    font-weight: ${weights.medium};
    ${respSpacing("margin-block-end", "3xs")};
  }

  .req-star {
    padding-left: ${pxToRem(4)};
  }

  //Maybe need to fix this
  code {
    display: inline-block;
    max-width: 100%;
    white-space: nowrap;
    overflow-x: auto;
    background-color: ${NeutralBgDefault};
    color: ${NeutralTxtStrongDefault};
    font-size: ${pxToRem(16)};
    font-family: ${fonts.secondary};
    padding: ${pxToRem(12)} ${pxToRem(20)};
    border-radius: ${pxToRem(16)};

    ${mediaQueries.xl} {
      padding: ${pxToRem(24)} ${pxToRem(40)};
      border-radius: ${pxToRem(32)};
    }
  }

  pre {
    overflow-x: auto;
    background-color: ${NeutralBgDefault};
    padding: ${pxToRem(12)} ${pxToRem(20)};
    border-radius: ${pxToRem(16)};

    code {
      display: inline;
      padding: 0;
      white-space: pre;
    }

    ${mediaQueries.xl} {
      padding: ${pxToRem(24)} ${pxToRem(40)};
      border-radius: ${pxToRem(32)};
    }
  }

  img {
    max-width: 100%;
  }
`;